module.exports = __webpack_public_path__ + "static/media/3.b8bece69.jpg";